import { DeterministicCheck, LocaleConfig, RiskLevel, SemanticEvaluation } from './types';
import { blockingIssues } from './quality';

export interface PublicationDecision {
  status: 'PUBLISHED' | 'REVIEW_REQUIRED' | 'FAILED';
  reason: string;
}

export function decidePublication(
  riskLevel: RiskLevel,
  locale: LocaleConfig,
  deterministicChecks: DeterministicCheck[],
  semantic: SemanticEvaluation,
): PublicationDecision {
  const blockers = blockingIssues(deterministicChecks);
  if (blockers.length > 0) {
    return { status: 'REVIEW_REQUIRED', reason: blockers.join('; ') };
  }
  if (!locale.autoPublishEnabled) {
    return { status: 'REVIEW_REQUIRED', reason: `${locale.displayName} auto-publish is disabled.` };
  }
  if (riskLevel === 'HIGH') {
    return { status: 'REVIEW_REQUIRED', reason: 'High-risk security or destructive content requires human exception review.' };
  }
  if (semantic.criticalOmission) {
    return { status: 'REVIEW_REQUIRED', reason: 'Semantic QE found a critical omission.' };
  }
  if (semantic.securityAmbiguity) {
    return { status: 'REVIEW_REQUIRED', reason: 'Semantic QE found security ambiguity.' };
  }
  if (semantic.overallScore < locale.qualityThreshold) {
    return { status: 'REVIEW_REQUIRED', reason: `Quality score ${semantic.overallScore} is below threshold ${locale.qualityThreshold}.` };
  }
  return { status: 'PUBLISHED', reason: 'Passed deterministic QA, semantic QE, and policy gate.' };
}
